/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Note_EditInputs */

const en_us2_exercise_personal_note_edit = /** @type {(inputs: Exercise_Personal_Note_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const pt_br2_exercise_personal_note_edit = /** @type {(inputs: Exercise_Personal_Note_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const es_419_exercise_personal_note_edit = /** @type {(inputs: Exercise_Personal_Note_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const pt_pt2_exercise_personal_note_edit = /** @type {(inputs: Exercise_Personal_Note_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const fr_fr2_exercise_personal_note_edit = /** @type {(inputs: Exercise_Personal_Note_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const de_de2_exercise_personal_note_edit = /** @type {(inputs: Exercise_Personal_Note_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const it_it2_exercise_personal_note_edit = /** @type {(inputs: Exercise_Personal_Note_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Exercise_Personal_Note_EditInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_note_edit = /** @type {((inputs?: Exercise_Personal_Note_EditInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Note_EditInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_note_edit(inputs)
	if (locale === "es-419") return es_419_exercise_personal_note_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_note_edit(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_note_edit(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_note_edit(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_note_edit(inputs)
	return en_us2_exercise_personal_note_edit(inputs)
});
export { exercise_personal_note_edit as "exercise-personal.note_edit" }